export default {
    getScoresByType(type, axios) {
        return axios({
            url: `scores/type/${type}`,
            method: 'GET'
        })
    },
    getScores(axios) {
        return axios({
            url: `scores`,
            method: 'GET'
        })
    },
    getScoreById(id, axios) {
        return axios({
            url: `scores/${id}/view`,
            method: 'GET'
        })
    },
    getScoreGroupId(scoreId, groupId, axios) {
        return axios({
            url: `scores/${scoreId}/group/${groupId}/view`,
            method: 'GET'
        })
    },
    createScore(data, axios) {
        return axios({
            url: `scores/add`,
            method: 'POST',
            data: data
        })
    },
    createScoreGroup(id, data, axios) {
        return axios({
            url: `scores/${id}/group/add`,
            method: 'POST',
            data: data
        })
    },
    updateScore(id, data, axios) {
        return axios({
            url: `scores/${id}/update`,
            method: 'POST',
            data: data
        })
    },
    updateScoreGroup(scoreId, groupId, data, axios) {
        return axios({
            url: `scores/${scoreId}/group/${groupId}/update`,
            method: 'POST',
            data: data
        })
    },
    deleteScore(id, axios) {
        return axios({
            url: `scores/${id}/delete`,
            method: 'DELETE'
        })
    },

    deleteScoreGroup(scoreId, groupId, axios) {
        return axios({
            url: `scores/${scoreId}/group/${groupId}/delete`,
            method: 'DELETE'
        })
    },

    archive(id, axios) {
        return axios({
            url: `scores/${id}/archive`,
            method: 'POST'
        })
    },

    unarchive(id, axios) {
        return axios({
            url: `scores/${id}/unarchive`,
            method: 'POST'
        })
    },

}
